import DateFnsUtils from '@date-io/date-fns';
import {
  DatePicker,
  DatePickerView,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import frLocale from 'date-fns/locale/fr';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../../App/redux/store';
import CheckBox from '../../../../../components/Forms/CheckBox';
import useUsers from '../../../../users/useUsers';
import { fetchCompanyStatsThunk } from '../../../services/companyThunks';
import useCompany from '../../../useCompany';
import styles from './companyStatsDateForm.module.scss';

const CompanyStatsDateForm = () => {
  const { companyIdIri } = useCompany();
  const { users } = useUsers();
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString());
  const [onlyYear, setOnlyYear] = useState(false);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (companyIdIri && users) {
      dispatch(
        fetchCompanyStatsThunk({
          companyIdIri,
          date: selectedDate,
          onlyYear,
          users,
        }),
      );
    }
  }, [selectedDate, onlyYear, companyIdIri, users]);

  const handleDisplay = () => {
    const result = onlyYear ? ['year'] : ['month', 'year'];
    return result as DatePickerView[];
  };

  return (
    <form className={styles.companyStatsDateForm}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
        <DatePicker
          value={selectedDate}
          views={handleDisplay()}
          inputVariant="outlined"
          minDate={new Date('2015-01-01')}
          maxDate={new Date()}
          onChange={(date) => setSelectedDate(new Date(date as any).toISOString())}
        />
      </MuiPickersUtilsProvider>

      <CheckBox
        name="onlyYear"
        checked={onlyYear}
        handleChange={(e) => setOnlyYear(e.target.checked)}
        label="Année uniquement"
      />
    </form>
  );
};

export default CompanyStatsDateForm;
